import React, { useCallback, useEffect, useState, useRef } from "react";
import Logo from "../../../assets/images/logo.svg";
import ArLogo from "../../../assets/images/Saudia TYS logo_colour.png";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import Language from "../../../assets/images/icons/language.svg";
import Plane from "../../../assets/images/icons/plane.svg";
import DownAngle from "../../../assets/images/icons/down-angle.svg";
import { useLanguage } from "../../../context/LanguageContext";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";

function Header() {
    const menuRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const { language, setLanguage } = useLanguage();
    const [bookingTicketUrl, setBookingTicketUrl] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    const handleLanguageSelect = (langCode) => {
        setLanguage(langCode);
    };

    const fetchBookingTicket = useCallback(async () => {
        try {
            const response = await handleApiCall("get", endpoints.getSoundTrackBookingTicket);
            if (
                response?.data?.code === 200 ||
                response?.data?.code === "200" ||
                response?.data?.success === true
            ) {
                const ticketUrl = response?.data?.data?.bookingTicket?.ticket_url || "";
                setBookingTicketUrl(ticketUrl);
            }
        } catch (error) {
            console.error("Error fetching booking ticket:", error);
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                menuOpen &&
                menuRef.current &&
                !menuRef.current.contains(e.target)
            ) {
                setMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    const handleMenuToggle = (e) => {
        e.stopPropagation(); // prevent outside-click handler
        setMenuOpen(prev => !prev);
    };

    useEffect(() => {
        fetchBookingTicket();
    }, [fetchBookingTicket]);

    useEffect(() => {
        if (language === "AR") {
            document.body.setAttribute("dir", "rtl");
            document.body.classList.add("rtl");
        } else {
            document.body.setAttribute("dir", "ltr");
            document.body.classList.remove("rtl");
        }
    }, [language]);

    useEffect(() => {
        const handleWindowScroll = () => {
        if (menuOpen) {
            setMenuOpen(false);
        }
    };

    window.addEventListener("scroll", handleWindowScroll);

    return () => {
        window.removeEventListener("scroll", handleWindowScroll);
    };
    }, [menuOpen]);

    // Handle scrolling to section when navigating to home page with hash
    useEffect(() => {
        const hash = location.hash;
        if ((location.pathname === "/" || location.pathname === "") && hash) {
            const targetId = hash.substring(1);
            // Wait a bit for the page to render
            setTimeout(() => {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const offset = 150;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            }, 100);
        }
    }, [location]);

    const handleScroll = (e) => {
        e.preventDefault();

        const href = e.currentTarget.getAttribute("href");

        if (!href) return;

        if (href.startsWith("#")) {
            const targetId = href.substring(1);
            const isHomePage = location.pathname === "/" || location.pathname === "";

            if (isHomePage) {
                // If already on home page, scroll to section
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const offset = 150;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            } else {
                // If not on home page, navigate to home page with hash
                navigate(`/${href}`);
                // Wait for navigation to complete, then scroll
                setTimeout(() => {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const offset = 150;
                        const elementPosition = targetElement.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - offset;

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth",
                        });
                    }
                }, 100);
            }
        } else if (href === "/") {
            // Handle home page link
            navigate("/");
        } else {
            window.location.href = href;
        }
    };

  return (
    <>
        <header className="max-w-8xl mx-auto fixed inset-x-3 top-3 pl-6 pr-3 md:px-8 lg:px-8 z-50">
            <div className="relative z-50">
                <div className={`flex items-center py-4 px-0 md:px-2 lg:px-6`}>
                    {/* <div className="flex items-center gap-3">
                        <div className="logo">
                            <Link to="/"><img src={Logo} alt="Saudia Logo"/></Link>
                        </div>
                    </div> */}
                    <div className="flex items-center gap-3 max-[767px]:-ml-2">
                        <div className="logo flex items-center">
                            <Link to="/" className="flex items-center gap-2">
                                <img
                                    src={language === "AR" ? ArLogo : Logo}
                                    className="h-8 md:h-10 w-auto"
                                />
                                <span
                                    className={`text-saudiaGreen text-lg md:text-xl ${
                                        language === "AR"
                                            ? "font-SaudiaArabic text-right"
                                            : "font-SaudiaBold text-left"
                                    }`}
                                >
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div ref={menuRef} className={`ml-auto ${language === "AR" ? "max-[767px]:mr-2.5": ""}`}>
                    <div className={`absolute top-20 md:top-0 pt-2 pb-5 md:py-0 px-6 border rounded-[4px] md:rounded-none border-saudiaGreen md:border-0 md:px-0 md:relative bg-white md:bg-transparent md:w-auto -left-6 -right-[13px] md:inset-0 ${menuOpen ? "flex justify-end flex-col items-end": "hidden md:flex flex-1"}`}>
                        <nav className={`flex flex-col md:flex-row w-full md:w-auto mb-5 md:mb-0 md:items-center lg:gap-10 [&_a]:transition-all [&_a]:text-saudiaGreen hover:[&_a]:opacity-100 [&_a:not(.active)]:opacity-100 font-SaudiaRegular max-[767px]:[&_a]:py-4 max-[767px]:[&_a]:text-end max-[767px]:[&_a]:border-b max-[767px]:[&_a]:border-saudiaGreen text-lg md:text-sm ${language === "AR" ? "md:ml-auto md:mr-20 md:[&_a]:ml-10" : " md:mr-auto md:ml-20 md:[&_a]:mr-10"}`}>
                            <a href="/" onClick={handleScroll}>{language === "AR" ? "الصفحة الرئيسية" : "Home"}</a>
                            <a href="#news" onClick={handleScroll}>{language === "AR" ? "الأخبار" : "News"}</a>
                            <a href="#games" onClick={handleScroll}>{language === "AR" ? "الألعاب" : "Games"}</a>
                            <a href="#saudia-competition" onClick={handleScroll}>{language === "AR" ? "مسابقات" : "Competitions"}</a>
                        </nav>
                        {bookingTicketUrl ? (
                            <a
                                href={bookingTicketUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`bg-saudiaGreen inline-flex px-2 md:px-3 lg:px-2 py-2 md:py-3 lg:py-2 items-center text-sm lg:text-lg font-SaudiaLight gap-x-2 text-white rounded-md ${language === "AR" ? "md:ml-4 lg:ml-8":"md:mr-4 lg:mr-8"}`}>
                                <img src={Plane} alt="Plane icon"/>{language === "AR" ? "حجز الرحلات" : "Book flights"}
                            </a>
                        ) : (
                            <Link className={`bg-saudiaGreen inline-flex px-2 md:px-3 lg:px-2 py-2 md:py-3 lg:py-2 items-center text-sm lg:text-lg font-SaudiaLight gap-x-2 text-white rounded-md ${language === "AR" ? "md:ml-4 lg:ml-8":"md:mr-4 lg:mr-8"}`}>
                                <img src={Plane} alt="Plane icon"/>{language === "AR" ? "حجز الرحلات" : "Book flights"}
                            </Link>
                        )}
                    </div>
                    <div className="flex md:hidden ml-auto">
                        {bookingTicketUrl ? (
                            <a
                                href={bookingTicketUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`bg-saudiaGreen inline-flex px-2 md:px-3 lg:px-2 py-2 md:py-3 lg:py-2 items-center text-xs font-SaudiaLight gap-x-1 text-white rounded-md ${language === "AR" ? "md:ml-4 lg:ml-8":"md:mr-4 lg:mr-8"}`}>
                                <img src={Plane} alt="Plane icon" className="h-3"/>{language === "AR" ? "حجز الرحلات" : "Book flights"}
                            </a>
                        ) : (
                            <Link className={`bg-saudiaGreen inline-flex px-2 md:px-3 lg:px-2 py-2 md:py-3 lg:py-2 items-center text-sm lg:text-lg font-SaudiaLight gap-x-2 text-white rounded-md ${language === "AR" ? "md:ml-4 lg:ml-8":"md:mr-4 lg:mr-8"}`}>
                                <img src={Plane} alt="Plane icon"/>{language === "AR" ? "حجز الرحلات" : "Book flights"}
                            </Link>
                        )}
                        <button className="px-2 py-2 font-SaudiaBold text-saudiaGreen text-sm" onClick={handleMenuToggle}>{language === "AR" ? "القائمة" : "Menu"}</button>
                    </div>
                    </div>
                    <div className={`relative w-[80px] h-5 text-[10px] bg-white border border-green-700 rounded-full flex items-center cursor-pointer select-none overflow-hidden [&_.btn]:w-1/2 [&_.btn]:text-center [&_.btn]:h-full [&_.btn]:flex [&_.btn]:items-center [&_.btn]:justify-center [&_.btn]:z-10 [&_.btn]:font-SaudiaRegular max-[767px]:-mr-1 ${language === "AR" ? "max-[767px]:-ml-2.5": ""}`}>
                        <button
                            type="button"
                            onClick={() => handleLanguageSelect("EN")}
                            className={`btn ${language === "EN" ? "text-white bg-saudiaGreen" : "text-green-700"}`}
                        >
                            EN
                        </button>
                        <button
                            type="button"
                            onClick={() => handleLanguageSelect("AR")}
                            className={`btn ${language === "AR" ? "text-white bg-saudiaGreen" : "text-green-700"}`}
                        >
                            AR
                        </button>
                    </div>
                    {/* <div className="font-semibold flex gap-x-3 [&_.link]:transition-all">
                        <Link className='flex items-center gap-x-2'>
                            <img src={Language}/>
                            <img src={DownAngle}/>
                        </Link>
                    </div> */}
                </div>
            </div>
        </header>
        <svg className="invisible absolute" width="0" height="0" aria-hidden="true">
            <defs>
                <filter id="round">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
                    <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0  
                                0 1 0 0 0  
                                0 0 1 0 0  
                                0 0 1 19 -9"
                        result="goo"
                    />
                    <feComposite in="SourceGraphic" in2="goo" operator="atop" />
                </filter>
            </defs>
        </svg>
    </>
  )
}

export default Header